var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-ride-details"},[_c('GoogleMap',{attrs:{"dialogName":_vm.mapDialogName,"trackerCoordinates":this.coordinates},on:{"markerDragEnd":_vm.handleMarkerDragEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }